export const defaultTheme = {
  secondary: '#639FC3',
};
